import React from 'react';
import { Box } from '@chakra-ui/layout';
import { IIcon } from 'components/Icon/icons';
import { Flex, Tooltip as CTooltip, Heading } from '@chakra-ui/react';

import { Icon, TIconName } from 'components';
import { StyledLabel } from './styles';
import { Placement } from '@chakra-ui/popper';

interface ITProps {
  tip?: string | JSX.Element;
  placement?: Placement;
  width?: string;
}
const Tooltip = (props: ITProps): JSX.Element => {
  return (
    <CTooltip
      style={{ width: '70rem !important' }}
      closeDelay={300}
      bgColor="white"
      textColor="black"
      padding="10px"
      borderRadius="8px"
      shadow={props.width ? 'none' : 'md'}
      placement={props.placement === undefined ? 'top-start' : props.placement}
      aria-label="Tooltip Help"
      label={
        <Flex
          p={props.width ? '10px' : '0px'}
          bg="white"
          direction="column"
          w={props.width ?? 'auto'}
          shadow={props.width ? 'md' : '0'}
          borderRadius="8px"
        >
          <Heading color="brand.primary" fontWeight="700" fontSize="18px" mb="16px">
            Ajuda
          </Heading>
          {props.tip}
        </Flex>
      }
    >
      <span>
        <Icon name="exclamation" size={1} />
      </span>
    </CTooltip>
  );
};

interface ISProps {
  notMarginBottom?: boolean;
  flex?: number;
  color?: any;
  placement?: Placement;
  width?: string;
}

interface IProps extends ISProps {
  tip?: string | JSX.Element;
  htmlFor?: string;
  children: React.HTMLProps<HTMLLabelElement>['children'];
  iconName?: TIconName;
  $iconColor?: IIcon['$iconColor'];
  color?: string;
}

// eslint-disable-next-line react/display-name
export const Label = React.forwardRef(
  ({ tip, placement, width, ...props }: IProps, ref: React.ForwardedRef<any>) => (
    <Box display="flex" width="100%">
      <StyledLabel ref={ref} {...props} />
      {!!tip && <Tooltip width={width} placement={placement} tip={tip} />}
    </Box>
  ),
);
